/* global errorPanel */

import React from 'react'
import { api } from 'components/api'
import { createImagePath, updateImagePath } from 'components/routes/api'
import Cropper from 'cropperjs'

class Form extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      file: null,
      cropper: null
    }

    this.cropperRef = React.createRef()
    this.imageRef = React.createRef()
    this.saveRef = React.createRef()
    this.containerRef = React.createRef()
  }

  sendBlob = (blob) => {
    const formData = new FormData()
    formData.append('file', blob, 'logo.jpg')

    this.createNewImage(formData)
  }

  handleChange = (event) => {
    this.setState({ file: event.target.files[0] })

    const done = (url) => {
      $(this.cropperRef.current)
        .on('open.zf.reveal', () => {
          const cropper = new Cropper(this.imageRef.current, {
            aspectRatio: this.props.cropX / this.props.cropY,
            viewMode: 1,
            autoCropArea: 1
          })

          this.setState({ cropper })
        })
        .on('closed.zf.reveal', () => {
          if (this.state.cropper) {
            this.state.cropper.destroy()
          }
          this.setState({ file: null, cropper: null })
          $(this.props.fileInputRef.current).val('')
          $(this.cropperRef.current)
            .off('open.zf.reveal')
            .off('closed.zf.reveal')
        })

      $(this.saveRef.current).click(() => {
        if (this.state.cropper) {
          const canvas = this.state.cropper.getCroppedCanvas({
            imageSmoothingQuality: 'high'
          })
          if (typeof canvas.toBlob !== 'undefined') {
            canvas.toBlob((blob) => {
              this.sendBlob(blob)
            })
          } else {
            this.sendBlob(canvas.msToBlob())
          }

          $(this.containerRef)
            .removeClass('image-absent')
            .addClass('image-present')
          $(this.containerRef)
            .removeClass('image-absent')
            .addClass('image-present')

          $(this.cropperRef.current).foundation('close')
        }
      })
      $(this.props.fileInputRef.current).val('')
      $(this.imageRef.current).attr('src', url)

      $(this.cropperRef.current).foundation()
      $(this.cropperRef.current).foundation('open')
    }

    if (event.target.files[0]) {
      if (FileReader) {
        const reader = new FileReader()
        reader.onload = () => {
          done(reader.result)
        }
        reader.readAsDataURL(event.target.files[0])
      }
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()

    if (this.state.file) {
      const formData = new FormData()
      formData.append('file', this.state.file, this.state.file.name)

      this.props.imageId
        ? this.updateExistingImage(formData)
        : this.createNewImage(formData)
    }
  }

  createNewImage = (formData) => {
    api.postWithCsrf({
      url: createImagePath(),
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        const data = response.data
        this.props.updateImage(data.imageId, data.imageUrl)
      })
      .catch(() => {
        errorPanel(
          'Image could not be added. Please try again or contact support@procurated.com'
        )
      })
  }

  updateExistingImage = (formData) => {
    api.patchWithCsrf({
      url: updateImagePath(this.props.imageId),
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        const data = response.data
        this.props.updateImage(data.imageId, data.imageUrl)
      })
      .catch(() => {
        errorPanel(
          'Image could not be updated. Please try again or contact support@procurated.com'
        )
      })
  }

  render () {
    return (
      <div>
        <div className='reveal large vh-80' ref={this.cropperRef} data-reveal>
          <div className='img-container'>
            <img src='' ref={this.imageRef} className='vh-60' />
          </div>

          <div>
            <hr />
            <div className='space-between'>
              <button
                type='button'
                className='button hollow large'
                onClick={(e) => {
                  $(this.cropperRef.current).foundation('close')
                  this.props.handleCancelUpload(e)
                  $(this.props.fileInputRef.current).val('')
                  $(this.imageRef.current).attr('src', '')
                }}
              >
                Cancel
              </button>
              <button type='button' className='button large' ref={this.saveRef}>
                Crop
              </button>
            </div>
          </div>
        </div>

        <div />
        <div className='grid-x grid-margin-x' ref={this.containerRef}>
          <div className='small-12 cell'>
            <form id='image-upload-form'>
              <input
                type='file'
                accept='image/*'
                multiple={false}
                onChange={(e) => this.handleChange(e)}
                ref={this.props.fileInputRef}
                className='hide'
              />
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export default Form
